/* eslint-disable react/react-in-jsx-scope */
import FormTextInput from '../elements/FormTextInput'

const MandatoryCheckContent = ({ formDisabled, mandatoryCheckDetails }) => [
  {
    id: 'mandatory-check-form-details',
    name: 'Qualifications',
    inputs: [
      {
        id: 'mandatoryCheck',
        size: 12,
        field: (
          <FormTextInput
            name="mandatoryCheck"
            label={mandatoryCheckDetails.FIELD_LABEL ?? 'Mandatory check info'}
            required={!!mandatoryCheckDetails.FIELD_REQ}
            autoComplete="new-mandatoryCheck"
            disabled={formDisabled}
          />
        ),
      },
    ],
  },
]

export default MandatoryCheckContent
